export default {
    listagem: {
        titulo_pagina: 'Lista de Transmisión',
        table: {
            transmissao: "Transmisión",
            resposta: "Respuesta",
            mensagem: "Mensaje",
            criadoem: "Creado en",
            empty: "No se encontró transmisión",
            visualizar: "Ver"
        }
    },
    show: {
        title: 'Ver Transmisión'
    },
    form: {
        titulo_pagina: {
            criar: 'Crear Nueva Transmisión',
            editar: 'Editar Transmisión'
        },
        fields: {
            nome: {
                label: 'Nombre',
                description: 'Nombre del Estado'
            },
            botao_salvar : 'Transmitir Resultado'
        },
        create: {
            success: "¡Resultado transmitido con éxito!",
            error: "¡Error al transmitir el resultado!"
        },
        update: {
            success: "¡Resultado editado con éxito!",
            error: "¡Error al editar el resultado!"
        }
    },
    transmissao: {
        titulo_pagina: 'Informar Examen a Interoperabilidad',
        importacao_massa: 'Importación Masiva',
        funcionalidade_contrucao: 'Funcionalidad en Construcción...',
        escolha_arquivo_importacao: 'Elegir un archivo para importar',
        arraste_solte_arquivo: 'O arrastra y suelta un archivo aquí',
        selecionar: 'Seleccionar',
        separador: 'Separador',
        arquivo_importacao_valores: {
            tab: 'Tabulador',
            pipe: 'Barra vertical',
            espaco: 'Espacio',
            virgula: 'Coma',
            ponto: 'Punto'
        },
        quantidade_coluna: 'Cantidad de Columnas',
        importar: 'Importar',
        campos: {
            id_resultado_label: 'ID del Resultado',
            id_resultado_descricao: 'ID del Resultado',
            cpf_label: 'CPF',
            cpf_descricao: 'CPF del Paciente',
            nome_label: 'Nombre',
            nome_descricao: 'Nombre del Paciente',
            data_nascimento_label: 'Fecha de Nacimiento',
            data_nascimento_descricao: 'Fecha de Nacimiento',
            genero_label: 'Género',
            genero_descricao: 'Género del Paciente',
            genero_valores: {
                masculino: 'Masculino',
                feminino: 'Femenino'
            },
            endereco_label: 'Dirección',
            endereco_descricao: 'Dirección del Paciente',
            cep_label: 'Código Postal',
            cep_descricao: 'Código Postal',
            exame_label: 'Examen',
            resultado_label: 'Resultado',
            resultado_valores: {
                detectavel: 'Detectable',
                nao_detectavel: 'No Detectable',
                inconclusivo: 'Inconcluso',
            },
            amostra_biologica_label: 'Muestra Biológica',
            data_label: 'Fecha',
            data_descricao: 'Fecha de Procesamiento',
            uf_laboratorio_label: 'Estado del Laboratorio'
        },
        reporte_enviado: '¡Reporte Enviado! Consulta la lista para el Estado',
        erro_reportar_exame: 'Error al Informar Examen'
    }
    
}
